/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Event_Group_RemovedInputs */

const en_work_order_publish_event_group_removed = /** @type {(inputs: Work_Order_Publish_Event_Group_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Group to publish has been removed`)
};

const fr_work_order_publish_event_group_removed = /** @type {(inputs: Work_Order_Publish_Event_Group_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le groupe d’événements à publier a été supprimé`)
};

const de_work_order_publish_event_group_removed = /** @type {(inputs: Work_Order_Publish_Event_Group_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die zu veröffentlichende Ereignisgruppe wurde entfernt.`)
};

const it_work_order_publish_event_group_removed = /** @type {(inputs: Work_Order_Publish_Event_Group_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il gruppo di eventi da pubblicare è stato rimosso`)
};

const ru_work_order_publish_event_group_removed = /** @type {(inputs: Work_Order_Publish_Event_Group_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа мероприятий, готовящаяся к публикации, удалена.`)
};

const es_work_order_publish_event_group_removed = /** @type {(inputs: Work_Order_Publish_Event_Group_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se ha eliminado el grupo de eventos para publicar`)
};

const zh_cn2_work_order_publish_event_group_removed = /** @type {(inputs: Work_Order_Publish_Event_Group_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动组已移除，无法发布`)
};

const ja_work_order_publish_event_group_removed = /** @type {(inputs: Work_Order_Publish_Event_Group_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開するイベントグループが削除されました`)
};

const hi_work_order_publish_event_group_removed = /** @type {(inputs: Work_Order_Publish_Event_Group_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकाशन हेतु इवेंट ग्रुप को हटा दिया गया है।`)
};

const pt_pt2_work_order_publish_event_group_removed = /** @type {(inputs: Work_Order_Publish_Event_Group_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O grupo de eventos que iria publicar foi removido.`)
};

/**
* | output |
* | --- |
* | "Event Group to publish has been removed" |
*
* @param {Work_Order_Publish_Event_Group_RemovedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_event_group_removed = /** @type {((inputs?: Work_Order_Publish_Event_Group_RemovedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Event_Group_RemovedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_event_group_removed(inputs)
	if (locale === "de") return de_work_order_publish_event_group_removed(inputs)
	if (locale === "it") return it_work_order_publish_event_group_removed(inputs)
	if (locale === "ru") return ru_work_order_publish_event_group_removed(inputs)
	if (locale === "es") return es_work_order_publish_event_group_removed(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_event_group_removed(inputs)
	if (locale === "ja") return ja_work_order_publish_event_group_removed(inputs)
	if (locale === "hi") return hi_work_order_publish_event_group_removed(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_event_group_removed(inputs)
	return en_work_order_publish_event_group_removed(inputs)
});